import { IEvent } from "@Interfaces";
import { isListingVariantType } from "@Modules/eventPage/components/OfferingVariationSelector/OfferingVariationSelector.utils";

export const isAutoDebitActiveOnMainListingData = (
    eventData: IEvent.IEventData
) => {
    // return true if auto debit is enabled & it is main listing not variant
    return eventData?.is_auto_debit_active && !isListingVariantType(eventData);
};
